import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./RadioInputStyles";

export default class RadioInput extends Component {
  render() {
    const {
      input: { value, onChange }
    } = this.props;

    return (
      <div className={css(styles.inputWrapper)}>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="Flat"
            name="Flat"
            checked={value === "Flat"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="Flat" className={css(styles.label)}>
            Flat
          </label>
        </div>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="Detached"
            name="Detached"
            checked={value === "Detached"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="Detached" className={css(styles.label)}>
            Detached
          </label>
        </div>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="Semi_detached"
            name="Semi_detached"
            checked={value === "Semi_detached"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="Semi_detached" className={css(styles.label)}>
            Semi Detached
          </label>
        </div>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="Terraced"
            name="Terraced"
            checked={value === "Terraced"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="Terraced" className={css(styles.label)}>
            Terraced
          </label>
        </div>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="End_of_terrace"
            name="End_of_terrace"
            checked={value === "End_of_terrace"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="End_of_terrace" className={css(styles.label)}>
            End of Terrace
          </label>
        </div>
        <div className={css(styles.flexField)}>
          <input
            className={css(styles.input)}
            type="radio"
            value="Bungalow"
            name="Bungalow"
            checked={value === "Bungalow"}
            onChange={e => onChange(e)}
          />
          <label htmlFor="Bungalow" className={css(styles.label)}>
            Bungalow
          </label>
        </div>
      </div>
    );
  }
}
